export default __webpack_public_path__ + "static/media/icon_urheilutoiminta_aloittamatta.0557ebb2.svg";